export enum PcReservationTrackEvents {
  CANCEL_BUTTON_CLICKED = 'PC_RESERVATION_cancel_button_clicked',
  CANCEL_MODAL_DISMISSED = 'PC_RESERVATION_cancel_modal_dismissed',
  CANCEL_CONFIRMED = 'PC_RESERVATION_cancel_confirmed',
  CANCEL_SUCCESS = 'PC_RESERVATION_cancel_success',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/pc-reservation-track-events.enum.ts